import styled from 'styled-components';

export const StyledHeadingBanner = styled.div`
  border-top: 1px solid var(--border-color);
  ${'' /* background-color: var(--muted); */}
  padding: 6rem 4rem;
  padding-bottom: 4rem;
  display: grid;
  ${'' /* grid-template-rows: 1fr 6fr 3fr; */}
  align-items: center;
  grid-gap: 1rem;
  place-content: center;
  text-align: center;
  h1 {
    font-size: 5.5rem;
    line-height: 5rem;
    margin: 0;
    padding-bottom: 2rem;
    font-weight: 800;
    letter-spacing: 2px;
    /* Fallback: Set a background color. */
    background-color: var(--blue);
    background-image: linear-gradient(45deg, var(--blue), var(--indigo));
    -webkit-background-clip: text;
    -moz-background-clip: text;
    -webkit-text-fill-color: transparent;
    -moz-text-fill-color: transparent;
  }
  .lead {
    font-size: 2rem;
    line-height: 2.5rem;
    ${'' /* color: var(--muted-strong); */}
    opacity: 0.9;
    font-weight: 500;
    padding-bottom: 0.5rem;
  }
  .gradient-primary {
    background-color: var(--blue);
    background-image: linear-gradient(45deg, var(--blue), var(--indigo));
  }
  .gradient-text {
    -webkit-background-clip: text;
    -moz-background-clip: text;
    -webkit-text-fill-color: transparent;
    -moz-text-fill-color: transparent;
  }
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints?.xxl}) {
    h1 {
      font-size: 5.5rem;
      line-height: 5rem;
    }
    .lead {
      font-size: 1.5rem;
      line-height: 2rem;
    }
  }
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints?.xl}) {
    grid-template-columns: 1fr;
    &::before {
      top: 25%;
      right: 0;
      width: 100%;
      bottom: 0;
      margin-top: 0;
      margin-right: 0;
      margin-bottom: -25%;
    }
    padding-top: 4rem;
  }
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints?.md}) {
    padding: 3rem 3rem;
    &::before {
      top: 25%;
      right: 0;
      width: 100%;
      bottom: 0;
      margin-top: 0;
      margin-right: 0;
      margin-bottom: -25%;
    }

    h1 {
      font-size: 5rem;
      line-height: 4rem;
    }
  }
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints?.sm}) {
    padding: 1.5rem 2rem;
    h1 {
      font-size: 4rem;
      line-height: 3.5rem;
      text-align: center;
    }
    .lead {
      font-size: 1.5rem;
      line-height: 2rem;
      text-align: center;
    }
  }
`;

export const StyledHeadingSectionBanner = styled.div`
  border-top: 1px solid var(--border-color);
  ${'' /* background-color: var(--muted); */}
  padding: 0rem 4rem;
  padding-top: 4rem;
  display: grid;
  ${'' /* grid-template-rows: 1fr 6fr 3fr; */}
  ${'' /* align-items: center;
  grid-gap: 1rem;
  place-content: center;
  text-align: center; */}
  h1 {
    font-size: 5.5rem;
    line-height: 5rem;
    margin: 0;
    padding-bottom: 2rem;
    font-weight: 800;
    letter-spacing: 2px;
    /* Fallback: Set a background color. */
    background-color: var(--blue);
    background-image: linear-gradient(45deg, var(--blue), var(--indigo));
    -webkit-background-clip: text;
    -moz-background-clip: text;
    -webkit-text-fill-color: transparent;
    -moz-text-fill-color: transparent;
  }
  .lead {
    font-size: 2rem;
    line-height: 2.5rem;
    ${'' /* color: var(--muted-strong); */}
    opacity: 0.9;
    font-weight: 500;
    padding-bottom: 0.5rem;
  }
  .gradient-primary {
    background-color: var(--blue);
    background-image: linear-gradient(45deg, var(--blue), var(--indigo));
  }
  .gradient-text {
    -webkit-background-clip: text;
    -moz-background-clip: text;
    -webkit-text-fill-color: transparent;
    -moz-text-fill-color: transparent;
  }
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints?.xxl}) {
    h1 {
      font-size: 5.5rem;
      line-height: 5rem;
    }
    .lead {
      font-size: 1.5rem;
      line-height: 2rem;
    }
  }
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints?.xl}) {
    grid-template-columns: 1fr;
    &::before {
      top: 25%;
      right: 0;
      width: 100%;
      bottom: 0;
      margin-top: 0;
      margin-right: 0;
      margin-bottom: -25%;
    }
    padding-top: 4rem;
  }
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints?.md}) {
    padding: 3rem 3rem;
    &::before {
      top: 25%;
      right: 0;
      width: 100%;
      bottom: 0;
      margin-top: 0;
      margin-right: 0;
      margin-bottom: -25%;
    }

    h1 {
      font-size: 5rem;
      line-height: 4rem;
    }
  }
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints?.sm}) {
    padding: 1.5rem 2rem;
    h1 {
      font-size: 4rem;
      line-height: 3.5rem;
      text-align: center;
    }
    .lead {
      font-size: 1.5rem;
      line-height: 2rem;
      text-align: center;
    }
  }
`;
